/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Happy_Loved_Stork_AdviseInputs */

const en_happy_loved_stork_advise = /** @type {(inputs: Happy_Loved_Stork_AdviseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversations`)
};

const de_happy_loved_stork_advise = /** @type {(inputs: Happy_Loved_Stork_AdviseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konversationen`)
};

/**
* | output |
* | --- |
* | "Conversations" |
*
* @param {Happy_Loved_Stork_AdviseInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const happy_loved_stork_advise = /** @type {((inputs?: Happy_Loved_Stork_AdviseInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Happy_Loved_Stork_AdviseInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_happy_loved_stork_advise(inputs)
	return de_happy_loved_stork_advise(inputs)
});